import { OptionCard, StepHeading } from "@/components/booking/OptionCard";
import { gbp } from "@/lib/booking";

export function StepService({ catalog, form, set }) {
  return (
    <div>
      <StepHeading title="Which service do you need?" hint="Every price is fixed per property - no hourly rates, no surprises." />
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {catalog.services.map((s) => (
          <OptionCard
            key={s.slug}
            testId={`booking-service-${s.slug}`}
            selected={form.service_slug === s.slug}
            onClick={() => set({
              service_slug: s.slug, property_key: "", frequency: s.has_frequency ? form.frequency : "",
              extras: form.extras.filter((k) => !(s.included_extras || []).includes(k)),
            })}
            title={s.name}
            subtitle={`${s.description} From ${gbp(s.from_price)}.`}
          />
        ))}
      </div>
    </div>
  );
}

export function StepProperty({ service, form, set }) {
  return (
    <div>
      <StepHeading title="Tell us about your space." hint={`Fixed prices for ${service.name.toLowerCase()}.`} />
      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {service.properties.map((p) => (
          <OptionCard
            key={p.key}
            testId={`booking-property-${p.key}`}
            selected={form.property_key === p.key}
            onClick={() => set({ property_key: p.key })}
            title={p.label}
            price={gbp(p.price)}
          />
        ))}
      </div>
      <p className="mt-5 text-xs leading-relaxed text-faint">
        Larger property or something different? <a href="/contact" className="text-blue underline underline-offset-4">Get in touch</a> and we'll help.
      </p>
    </div>
  );
}

export function StepFrequency({ catalog, form, set }) {
  return (
    <div>
      <StepHeading
        title="How often would you like us?"
        hint="Your regular cleaning preference. Each clean is booked and paid as a separate one-time payment - no subscription."
      />
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {catalog.frequencies.map((f) => (
          <OptionCard
            key={f.value}
            testId={`booking-frequency-${f.value}`}
            selected={form.frequency === f.value}
            onClick={() => set({ frequency: f.value })}
            title={f.label}
          />
        ))}
      </div>
    </div>
  );
}
